export enum TransferForm {
  FromNameBrackets = 'Ro+c',
  FromIDBrackets = 'Ji0l',
  ToNameBrackets = 'Y2gJ',
  ToIDBrackets = 'tD5s',
  TransferFrom = '0txp',
  CancelTransfer = '3FMk',
  cancelTransfer = '06jp',
  PreEventHyphen = 'XjJX',
  DuringEvent = 'CtTy',
  OutsideofEvent = 'AYPf',
  transfersBrackets = 'vQog',
  TransfersBrackets = 'Bm9C',
  ThisTransfer = 'pPHV',
  transfer = 'J/V2',
  TransferUnit = 'Nsvd',
  QtyRequested = 'FWH/',
  QtyReversed = 'k6HH',
  ReceivedCost = 'QTp/',
  RequestCost = 'nleb',
  ReversedCost = 'wES7',
  TransferType = 'rmlv',
  TransferDate = 'HhD8',
  TransferGroupName = 'WE/A',
  EnterTransferGroupName = 'f6aw',
  QtyReceived = 'hzwH',
  PARQty = 'Nk17',
  QOHFrom = 'dCoN',
  QOHTo = 'T7WT',
  TransferSummary = 'OfNH',
  DuplicateTransfer = '7EyD',
  ClearQtyRequested = 'FjeM',
  ClearQtyReceived = 'Qitn',
  ClearQty = 'SOF1',
  SaveAsaTemplate = 'Mdk+',
  EnterTemplateName = 'j10Q',
  TemplateName = '+V6X',
  NewTemplate = 'Ivxd',
  BtnReplenish = '+BIK',
  BtnBulkReplenish = 'qDJq',
  BtnReplenishQOH = 'my3P',
  BtnReplenishZeroQOH = 'YYDn',
  BtnReplenishEndingCountExpectedQty = '03lN',
  BtnBulkReplenishQOH = 'u3La',
  BtnBulkReplenishZeroQOH = '7smQ',
  BtnBulkReplenishEndingCountExpectedQty = 'R2kF',
  AreYouSureYouWantToClearAllType = 'MqB8',
  TransferUnitTooltip = 'qVAQ',
  CompletedTransfer = 'JUIV',
  TransferID = 'xriA',
  TransactionDateTime = 'Jucv',
  Qty = 'qb6c',
  QtyInBaseUnit = 'bzUB',
  PendingTransferList = '/FOF',
  FromName = 'Ro+cA',
  FromID = 'Ji0lw',
  ToName = 'Y2gJA',
  ToID = 'tD5s0',
  PreEventInTransferSummary = 'fyXU',
  DuringEventInTransferSummary = 'bLnv',
  DuringEventOutTransferSummary = 'IzDF',

  CreateNewTransferFromTransferQTY = 'jDLm',
  CreateNewTransferFromPhysicalQTY = 'uuMU',

  TransferQty = '+y4M',
  HistoricalEvent = 'UhT4',
  ShowAllItems = 'ap5r',
  ShowSelectedItems = 'RaSo',
  TransferDetails = 'Yw/m',
  NewTransferDestination = 'vfVz',
  ReplenishQOHTooltip = 'vI1+',
  ReplenishZeroQOHTooltip = 'jc7Y',
  ReplenishEndingCountOrExpectedQTYTooltip = 'YUXx',
  CreateDuringEventTransfer = 'Nqs6',
  In = 'i8HV',
  Out = 'mjxU',
  TransferItemBrackets = '5oge',
  NotReceived = '+F9q',
  Par = '3pk2',

  QuantityOnHand = 'pLIl',
  PendingQuantity = 'oxFj',
  QuantityRequested = 'x4rZ',

  submitAndComplete = 'lZ4M',

  CreateSpecificTypeTransfer = 'PPZ9',
  TransferCompleted = 'I0oq',
  createTransfer = 'ekeS',
  sitesAsTransferDestinations = 'KpEd',
  BulkReplenishToPAR = 'uAx9',
  ChooseTransferType = 'd4Qd',
  SaveasaTemplate = 'HUoP',
  ThisUpperCaseTransfer = 'OY9v',
  QtyPulled = 'e+FV',
}
